import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleMainMediaStatus } from '../../actions/mediaActions';
import HotspotWrapper from './HotspotWrapper/HotspotWrapper';

const mapStateToProps = state => {
  const { tours, images, panos, videos, audio, aid, icons, media } = state.publicTour;
  if (!tours) {
    return {
      aid,
      audio: state.media.audio,
      images: state.media.images,
      panos: state.media.panos,
      videos: state.media.videos,
      isMainMediaPlaying: state.media.isMainMediaPlaying,
      icons: state.media.icons,
      media: state.media,
      isPublic: false,
    };
  } else {
    return {
      aid,
      images,
      panos,
      videos,
      audio,
      isMainMediaPlaying: state.media.isMainMediaPlaying,
      icons,
      media,
      isPublic: true,
    };
  }
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      toggleMainMediaStatus,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(HotspotWrapper);
